"use client";

import {CircleXIcon, FileWarningIcon, SidebarClose, SidebarCloseIcon} from "lucide-react";
import {Label} from "@/components/ui/label";
import {Textarea} from "@/components/ui/textarea";
import { cn, getNestedError } from "@/lib/utils";

export const TextAreaElement = ({noBorderRadius, rows, size, hideHelper, width, extraStyles, readOnly, variant, className, disabled, fieldName, type, placeholder, label, helper, form, addMutationOnLoad, addMutationOnChange, onKeyDown}: any) => {
    const error = form.errors ? getNestedError(form.errors, fieldName) : null;

    return (
        <div className={className}>
            {label && (
                <div className={"mb-1"}>
                    <Label className={"font-semibold"}>{label}</Label>
                </div>
            )}
            <Textarea
                size={size ? size : "lg"}
                variant={variant ? variant : "plain"}
                readOnly={readOnly}
                className={cn(error ? "border border-red-600" : "", className)}
                sx={noBorderRadius ? {borderRadius: 0, ...extraStyles} : extraStyles}
                disabled={disabled}
                placeholder={placeholder}
                type={type}
                rows={rows}
                onKeyDown={(event: any) => {
                    if(onKeyDown) onKeyDown(event)
                }}
                {...form.getProps(
                    fieldName,
                    type === "number" ? "number" : "input",
                    addMutationOnLoad,
                    addMutationOnChange)}
            />
            {error && (
                <p className={"my-2 text-red-600 text-xs flex gap-2 items-center"}>
                    <CircleXIcon size={12} />
                    {error}
                </p>
            )}
            {!hideHelper && helper && (
                <p className={"mt-2 text-xs opacity-50"}>{helper}</p>
            )}
        </div>
    )
}